<!-- JsonEditor.vue -->
<template>
  <div>
    <div style="margin-bottom: 8px; text-align: right">
      <button @click="toggleMode" type="button">
        {{ showTextarea ? "Passer à l'éditeur JSON" : "Passer au mode texte" }}
      </button>
    </div>

    <textarea
      v-if="showTextarea"
      :style="textareaStyle"
      v-model="innerValue"
      @input="emitChange"
    ></textarea>

    <div v-else ref="editorContainer" :style="editorStyle"></div>
  </div>
</template>

<script>
import {
  ref,
  computed,
  watch,
  onBeforeUnmount,
  onMounted,
  nextTick,
} from "@vue/composition-api";
// import { createJSONEditor } from "vanilla-jsoneditor";

export default {
  name: "JsonEditor",
  props: {
    value: { type: String, default: "" },
    height: { type: Number, default: null },
  },
  setup(props, { emit }) {
    const innerValue = ref(props.value);
    // émet à chaque changement interne
    watch(innerValue, (val) => emit("input", val));
    const editor = ref(null);
    const editorContainer = ref(null);
    const showTextarea = ref(true);

    const emitChange = () => emit("input", innerValue.value);

    const parseJson = (val) => {
      try {
        return JSON.parse(val);
      } catch {
        return {};
      }
    };

    const mountEditor = async () => {
      await nextTick();
      destroyEditor();
      editor.value = createJSONEditor({
        target: editorContainer.value,
        props: {
          mode: "code",
          //   content: { json: parseJson(innerValue.value) },
          //   onChangeJSON: (newJson) => {
          //     innerValue.value = JSON.stringify(newJson, null, 2);
          //     emitChange();
          //   },
          //   onChangeText: (text) => {
          //     innerValue.value = text;
          //     emitChange();
          //   },
          /* 1️⃣  on démarre avec le texte brut */
          content: { text: innerValue.value },

          /* 2️⃣  un seul callback couvre tous les cas */
          onChange: (updated) => {
            // if ("text" in updated) {
            //   innerValue.value = updated.text;
            // } else if ("json" in updated) {
            //   innerValue.value = JSON.stringify(updated.json, null, 2);
            // }
            innerValue.value =
              "text" in updated
                ? updated.text
                : JSON.stringify(updated.json, null, 2);

            emitChange();
          },
        },
      });
    };

    const destroyEditor = () => {
      if (editor.value) {
        editor.value.destroy();
        editor.value = null;
      }
    };

    const toggleMode = async () => {
      if (showTextarea.value) {
        // -> éditeur
        showTextarea.value = false;
        await mountEditor();
      } else {
        // -> textarea

        if (editor.value) {
          const latest = editor.value.get();
          innerValue.value =
            "text" in latest
              ? latest.text
              : JSON.stringify(latest.json, null, 2);
          emitChange();
        }
        showTextarea.value = true;
        destroyEditor();
      }
    };

    // const toggleMode = async () => {
    //   if (showTextarea.value) {
    //     // on va passer à l’éditeur
    //     showTextarea.value = false;
    //     await mountEditor();
    //   } else {
    //     // on revient au textarea
    //     if (editor.value) {
    //       //innerValue.value = editor.value.getText(); // toujours sûr
    //       const current = editor.value.get();
    //       innerValue.value =
    //         "text" in current
    //           ? current.text
    //           : JSON.stringify(current.json, null, 2);
    //       emitChange();
    //     }
    //     showTextarea.value = true;
    //     destroyEditor();
    //   }
    // };

    // const toggleMode = async () => {
    //   showTextarea.value = !showTextarea.value;
    //   if (!showTextarea.value) {
    //     await mountEditor();
    //   } else {
    //     destroyEditor();
    //   }
    // };

    watch(
      () => props.value,
      (val) => {
        innerValue.value = val;
        if (!showTextarea.value && editor.value) {
          editor.value.updateProps({ content: { json: parseJson(val) } });
        }
      }
    );

    onMounted(() => {
      innerValue.value = props.value;
    });

    onBeforeUnmount(() => {
      destroyEditor();
    });

    const textareaStyle = computed(() => {
      const s = {
        width: "100%",
        fontFamily: "monospace",
        border: "1px solid #ccc",
        padding: "8px",
        boxSizing: "border-box",
      };
      if (props.height !== null) s.height = props.height + "px";
      return s;
    });

    const editorStyle = computed(() => {
      const s = { border: "1px solid #ccc" };
      if (props.height !== null) s.height = props.height + "px";
      return s;
    });

    return {
      innerValue,
      editorContainer,
      showTextarea,
      emitChange,
      toggleMode,
      textareaStyle,
      editorStyle,
    };
  },
};
</script>
